import styled, { css, keyframes } from 'styled-components';
import { switchProp } from 'styled-tools';

const COLORS = {
  white: '#ffffff',
  ligthGrey: '#E0E0E0',
  darkGrey: '#858585',
  labelSmall: '##BDBDBD',
  buttonGreen: '#01BEA4',
  disabledGrey: '#E0E0E0',
};

const fadeOut = keyframes`
  0% { opacity: 1; }
  100% { opacity: 0; }
`;

const Container = styled.section`
  display: flex;
  justify-content: flex-end;
  position: relative;
  width: 970px;

  ${switchProp('exit', {
    true: css`
      animation: ${fadeOut} 0.3s 0s both;
    `,
  })}

  @media (max-width: 1280px) {
    width: 100vw;
    width: 100%;

    > .credit-card {
      display: none;
    }
  }
`;

const formWrapperAnimation = keyframes`
  0% { opacity: 0; top: 0px; width: 680px; }
  100% { opacity: 1; top: 0; width: 780px; }
`;

const FormWrapper = styled.div`
  animation: ${formWrapperAnimation} 0.5s 0.3s both;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${COLORS.white};
  border-radius: 20px 20px 0 0;
  font-size: 10px;
  min-height: 420px;
  overflow: hidden;
  padding: 15px 30px 0 180px;
  width: 810px;
  position: relative;

  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 81%,
    rgba(255, 255, 255, 0) 100%
  );

  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=0 ); /* IE6-9 */

  @media (max-width: 1280px) {
    width: 100%;
    padding: 20px;
    background: white;
    overflow-y: auto;
  }
`;

export { Container, FormWrapper };
